export enum PromotionCardType {
  Gift,
  WaitFree,
}
